import { useMemo } from "react";
import { IUser, UserTitle } from "../../../../../models/users.interface";
import Table, { TableRef } from "../../../../Shared/Table/Table";
import { linkableUsersTableColumns } from "./linkableUsersTableColumns";

const mapUsersToTableUsers = (users: IUser[]): LinkableUsersTableItem[] => {
  const tableUsers = users.map((user) => {
    const tableUser: LinkableUsersTableItem = {
      id: user.id,
      email: user.email,
      firstName: user.firstName,
      lastName: user.lastName,
      phone: user.phone,
      entity: user.organization?.name,
      title: user.salutation ?? UserTitle.None,
    };
    return tableUser;
  });
  return tableUsers;
};

export type LinkableUsersTableItem = {
  id: string;
  entity?: string | null;
  firstName: string;
  lastName: string;
  title: string;
  email: string | null;
  phone: string;
};

type LinkableUsersTableProps = {
  users?: IUser[];
  tableRef?: React.Ref<TableRef>;
  disabled?: boolean;
  highlightText?: string;
};

const LinkableUsersTable = ({
  users,
  tableRef,
  disabled,
  highlightText,
}: LinkableUsersTableProps) => {
  const tableUsers: LinkableUsersTableItem[] = useMemo(
    () => mapUsersToTableUsers(users ?? []),
    [users]
  );
  const tableColumns = useMemo(() => linkableUsersTableColumns(highlightText), [
    highlightText,
  ]);

  return (
    <Table<LinkableUsersTableItem>
      ref={tableRef}
      tableData={tableUsers}
      tableColumns={tableColumns}
      sortable
      checkboxSelect
      checkboxSelectDisabled={disabled}
    />
  );
};

export default LinkableUsersTable;
